<template>
  <Breadcrumbs
      title="Verify Dealer"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealers', path: '/dealers' },
      { label: 'Verify Dealer', path: '/verify-dealer' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <verifyDealerForm/>
    </div>
  </div>
</template>

<script>

import verifyDealerForm from "@/pages/master_data/dealers/verifyDealerForm.vue";

export default {
  components: {
    verifyDealerForm
  }
}
</script>